module.exports = __webpack_public_path__ + "img/enterprise.8781c008.svg";